import React, { Suspense, lazy, useEffect, useState } from "react";
import { useAuth } from "@clerk/clerk-react";
import { bootstrapAtom, store, upgradeModalAtom } from "/atomstore";
import { ELITS_MODULE_REGISTRY, GLOBAL_INTERRUPTS, PERSONAS, LICENSE_INFO, TENANT_SECRET_KEYS } from './data';
import InitScreen from './startloader';
import { useAtomValue } from "jotai";

const LockModal = lazy(() => import('./components/LockModal'));


const LockModalMount = () => {
  const lockModal = useAtomValue(upgradeModalAtom);

  if (!lockModal.open) return null;

  return (
    <Suspense fallback={null}>
      <LockModal />
    </Suspense>
  );
};

function applyBootstrapToRegistriesOnce() {

  const boot = store.get(bootstrapAtom);
  if (!boot || !boot?.modules || !boot?.modules?.length > 0) return;

  // modules -> Record füllen
for (const entry of boot.modules) {
  const id = Object.keys(entry)[0];
  ELITS_MODULE_REGISTRY[id] = entry[id];
}

  console.log("ELITS MODULE", JSON.stringify(ELITS_MODULE_REGISTRY));
  // personas / triggers analog:
  // for (const p of boot.personas ?? []) PERSONA_REGISTRY[p.id] = p
  for (const t of boot.triggers ?? []) GLOBAL_INTERRUPTS.push(t);

  if (boot?.license_info) {

const li = boot?.license_info;

  LICENSE_INFO.member_email = li?.member_email ?? null;
  LICENSE_INFO.name = li?.name ?? null;
  LICENSE_INFO.role =li?.role ?? null,
  LICENSE_INFO.license_id_immutable = li?.license_id_immutable ?? null;
  LICENSE_INFO.license_type = li?.license_type ?? null;
  LICENSE_INFO.billing_period = li?.billing_period ?? null;
  LICENSE_INFO.status_license = li?.status_license ?? null;
  LICENSE_INFO.current_period_start_at = li?.current_period_start_at ?? null;
  LICENSE_INFO.current_period_end_at = li?.current_period_end_at ?? null;
  LICENSE_INFO.max_battle_deck_slots = li?.max_battle_deck_slots ?? 0;
  LICENSE_INFO.gesamt_punkte_auto = li?.gesamt_punkte_auto ?? 0;
  LICENSE_INFO.woechentliche_punkte_auto = li?.woechentliche_punkte_auto ?? 0;
  LICENSE_INFO.profile_image_url = li?.profile_image_url ?? null;
  LICENSE_INFO.referral_token_auto = li?.referral_token_auto ?? null;


LICENSE_INFO.internalisation_enabled = li?.internalisation_enabled ?? false;
LICENSE_INFO.timetravel_enabled = li?.timetravel_enabled ?? false;
LICENSE_INFO.personal_analytics_enabled = li?.personal_analytics_enabled ?? false;
LICENSE_INFO.text_export_enabled = li?.text_export_enabled ?? false;
LICENSE_INFO.saving_enabled = li?.saving_enabled ?? false;
LICENSE_INFO.lifecall_hud_enabled = li?.lifecall_hud_enabled ?? false;
LICENSE_INFO.gap_analysis_enabled = li?.gap_analysis_enabled ?? false;
LICENSE_INFO.support_level = li?.support_level ?? null;
LICENSE_INFO.marketplace_enabled = li?.marketplace_enabled ?? false;
LICENSE_INFO.persona_creation_enabled = li?.persona_creation_enabled ?? false;
LICENSE_INFO.audio_export_enabled = li?.audio_export_enabled ?? false;
LICENSE_INFO.primary_language = li.primary_language ?? null;
LICENSE_INFO.selling_languages = li.selling_languages ?? [];
}

if (boot?.tenant_secret_keys) {
const sk = boot?.tenant_secret_keys;
  TENANT_SECRET_KEYS.openai = sk?.openai ?? null;
  TENANT_SECRET_KEYS.groq = sk?.groq ?? null;
  TENANT_SECRET_KEYS.deepgram = sk?.deepgram ?? null;
  TENANT_SECRET_KEYS.gemini =sk?.gemini ?? null;
  TENANT_SECRET_KEYS.version = sk?.version ?? 0;
  TENANT_SECRET_KEYS.updated_at = sk?.updated_at ?? null;
}

  // Transport leeren
  store.set(bootstrapAtom, null);

  

}




const SessionActivator = ({ children }: { children: React.ReactNode }) => {
  const { userId, isLoaded } = useAuth();
  const [isActivated, setIsActivated] = useState(false);

  useEffect(() => {
    const activate = async () => {
      if (!isLoaded || !userId || isActivated) return;

      try {
        const response = await fetch("https://api.sellermind.de/api/activate", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ clerk_user_id: userId }),
        });

        const data = await response.json();

        if (data && data?.modules && data?.modules?.length > 0) {
          store.set(bootstrapAtom, {
            modules: data.modules ?? [],
            personas: data.personas ?? [],
            triggers: data.triggers ?? [],
            latest_save_state: data.latest_save_state ?? null,
            current_run: data.current_run ?? null,
            license_info: data.license_info ?? null,
            tenant_secret_keys: data.tenant_secret_keys ?? null,
          });
          console.log("bootstrapAtom now:", store.get(bootstrapAtom));
          applyBootstrapToRegistriesOnce();
          setIsActivated(true);
        }
      } catch (err) {
        console.error("Activation failed:", err);
      }
    };

    activate();
  }, [userId, isLoaded, isActivated]);
  if (!isActivated) return <InitScreen />;
  return (
  <>
    {children}
    <LockModalMount />
  </>
);
};

export default SessionActivator;
